/**
 * 데미지 숫자. 코드 생성 도트 숫자 폰트를 이미지로 배치해 원작 느낌을 낸다.
 * (일반=크림색, 크리티컬=주황, 플레이어 피격=보라)
 */

import Phaser from 'phaser';
import type { AssetTable } from '../assets/loader';
import { DEPTH } from '../game/depth';
import { settings } from './Settings';

export type DamageKind = 'normal' | 'crit' | 'player';

const TEXTURE: Record<DamageKind, string> = {
  normal: 'font-damage',
  crit: 'font-damage-crit',
  player: 'font-damage-player',
};

export class DamageNumbers {
  constructor(
    private readonly scene: Phaser.Scene,
    private readonly assets: AssetTable,
  ) {}

  show(x: number, y: number, amount: number, kind: DamageKind = 'normal'): void {
    const texture = TEXTURE[kind];
    const info = this.assets.get(texture);
    const digits = Math.max(1, Math.floor(amount)).toString().split('');
    const scale = (kind === 'crit' ? 1.35 : 1.1) * settings().damageScale;
    const spacing = info.frameWidth * scale * 0.82;

    const container = this.scene.add.container(x, y);
    container.setDepth(DEPTH.damageNumber);

    digits.forEach((d, i) => {
      const digit = this.scene.add.image(
        (i - (digits.length - 1) / 2) * spacing,
        kind === 'crit' ? Math.sin(i * 1.3) * 5 : 0,
        texture,
        Number(d),
      );
      digit.setScale(scale);
      container.add(digit);
      this.scene.tweens.add({
        targets: digit,
        y: digit.y - 6,
        duration: 90,
        delay: i * 28,
        yoyo: true,
        ease: 'Quad.Out',
      });
    });

    if (kind === 'crit') {
      const spark = this.scene.add.image(-(digits.length * spacing) / 2 - 12, -4, 'fx-hit', 0);
      spark.setScale(0.5).setAlpha(0.9);
      container.add(spark);
    }

    this.scene.tweens.add({
      targets: container,
      y: y - (kind === 'crit' ? 74 : 60),
      alpha: 0,
      duration: kind === 'crit' ? 820 : 700,
      ease: 'Quad.Out',
      onComplete: () => container.destroy(),
    });
  }

  showMiss(x: number, y: number): void {
    const image = this.scene.add.image(x, y, 'word-miss');
    image.setDepth(DEPTH.damageNumber);
    this.scene.tweens.add({
      targets: image,
      y: y - 52,
      alpha: 0,
      duration: 620,
      onComplete: () => image.destroy(),
    });
  }
}
